import React from 'react';
import clsx from 'clsx';
import styles from './UIGamecityImprovementTrackerSquare.module.scss';
import { CityImprovementTypes } from '@colonist/game-states';
export function UIGameCityImprovementTrackerSquare({ cityImprovementType, active, className }) {
    const cityImprovementTypeText = CityImprovementTypes[cityImprovementType].toLowerCase();
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.squareContainer, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.border
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.background, styles[cityImprovementTypeText], {
            [styles.inactive]: !active
        })
    }));
}
